import { theme } from './theme';

export const device = {
  mobileXS: `(min-width: ${theme.mQ.mobileXS}px)`,
  mobileS: `(min-width: ${theme.mQ.mobileS}px)`,
  mobileM: `(min-width: ${theme.mQ.mobileM}px)`,
  mobileD: `(min-width: ${theme.mQ.mobileD}px)`,
  mobileL: `(min-width: ${theme.mQ.mobileL}px)`,
  tablet: `(min-width: ${theme.mQ.tablet}px)`,
  tabletL: `(min-width: ${theme.mQ.tabletL}px)`,
  laptop: `(min-width: ${theme.mQ.laptop}px)`,
  laptopL: `(min-width: ${theme.mQ.laptopL}px)`,
  desktopS: `(min-width: ${theme.mQ.desktopS}px)`,
  desktop: `(min-width: ${theme.mQ.desktop}px)`,
};
